// Défilement horizontal des index scrollables, partagé par les deux gestes qui le déclenchent :
// les flèches ←/→ du clavier (index_keyboard_nav_controller) et les boutons ‹ › posés dans
// l'en-tête de la colonne actions (index_scroll_table_controller). Un seul endroit pour le pas
// et l'animation, sinon les deux finiraient par diverger.

// Un pas = une grosse colonne, pas un demi-écran : on garde un repère visuel entre deux appuis.
const SCROLL_STEP_RATIO = 0.4;
const MIN_SCROLL_STEP = 200;

export function horizontalScrollStep(scroller) {
  return Math.max(MIN_SCROLL_STEP, Math.round(scroller.clientWidth * SCROLL_STEP_RATIO));
}

export function horizontalScrollBehavior() {
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}

// `direction` vaut 1 vers la droite, -1 vers la gauche.
export function scrollHorizontallyBy(scroller, direction) {
  scroller.scrollBy({
    left: direction * horizontalScrollStep(scroller),
    behavior: horizontalScrollBehavior(),
  });
}
